<script>
	import Vue from "vue";
	import { mapState } from "vuex";
	import Multiselect from "vue-multiselect";
	import VueGoogleAutocomplete from "vue-google-autocomplete";
	import debounce from "vue-debounce";
  import i18n from "@/i18n";

	export default {
		components: {
			Multiselect,
			VueGoogleAutocomplete
		},
		data() {
			return {
				isLoadingT: false,
      			inputKeyT: 0, // force fresh some inputs
				validEstablishmentsT: [],
				customerName: null,
				$_debounceTimerT: null
			};
		},
		computed: {
			// ...mapGetters(["contacts"]),
			...mapState({
				appId: state => state.app.id,
				documentId: state => state.app.documentId,
				isRecurringInvoice: state => state.recurring.isRecurringInvoice,
				contacts: state => state.home.contacts
			}),
			third_account: {
				get() {
					return this.$store.state.home.third_account;
				},
				set(value) {
					this.$store.commit("third_account", value);
				}
			},
			tags: {
				get() {
					return this.$store.state.tags.tags;
				},
				set(tags) {
					this.$store.commit("tags", tags);
				}
			},
			details: {
				get() {
					return this.$store.state.home.details;
				},
				set(value) {
					this.$store.commit("details", value);
				}
			},
			showDetails: {
				get() {
					return this.$store.state.home.showDetails;
				},
				set(value) {
					this.$store.commit("showDetails", value);
				}
			},
			couponCode: {
				get() {
					return this.$store.state.vat.couponCode;
				},
				set(value) {
					this.$store.commit("couponCode", value);
				}
			},
			couponCodeAmount: {
				get() {
					return this.$store.state.vat.couponCodeAmount;
				},
				set(value) {
					this.$store.commit("couponCodeAmount", value);
				}
			}
		},
		watch: {
			third_account() {
				// Client created using the modal
				if (this.third_account && this.third_account?.modal === true) {
					this.selectContact(this.third_account, false);
					this.$bvModal.hide("modalTiersCreation");
				}
			}
		},
		created() {
			if (this.appId === 0) {
				this.third_account = {
					type: "organization",
					name: "",
					address: "",
					address2: "",
					location: "",
					details: "",
					new: true
				};
			}

			this.$_debounceTimerT = null;
		},
		methods: {
			debounce(method, timer) {
				if (this.$_debounceTimerT !== null) {
					clearTimeout(this.$_debounceTimerT);
				}

				this.$_debounceTimerT = setTimeout(() => {
					method();
				}, timer);
			},
			selectContact(contact, disableEstablishmentsLoading = false) {
				const _contact = contact;
				const { discount, tags, details } = contact ?? {};

				if (!this.documentId) {
					if (details) {
						this.details = details;
						this.showDetails = true;
					}

					if(tags)
						this.tags = tags;

					this.couponCode = i18n.t("Remise");
					this.couponCodeType = "%";
					this.couponCodePercent = discount;
				}

				this.validEstablishmentsT = [];

				if (_contact) {
					_contact.modal = false;

					if (_contact?.establishments) {
						// Load only establishments with place.formatted_address not null
						for (const establishment of _contact?.establishments) {
							if (establishment?.place?.formatted_address !== "") {
								this.validEstablishmentsT.push(establishment);
							}
						}
					}

					if (disableEstablishmentsLoading === false || disableEstablishmentsLoading === null) {
						let selectedEstablishment = null;

						if (this.validEstablishmentsT.length > 0) {
							for (const establishment of Object.values(this.validEstablishmentsT)) {
								if (establishment?.is_headquarters === 1) {
									selectedEstablishment = {
										...establishment
									};
									break;
								}
							}

							if (!selectedEstablishment) {
								selectedEstablishment = {
									...this.validEstablishmentsT[0]
								};
							}

							if (selectedEstablishment && selectedEstablishment?.place) {
								_contact.location = this.constructLocation(selectedEstablishment.place);
								_contact.address = this.constructAddress(selectedEstablishment.place);
							}
						}

						this.third_account = { ..._contact };
					}
				}

				return _contact;
			},
			clientsSearch(search) {

				this.debounce(async () => {
					this.isLoadingT = true;

					this.$store.dispatch("relationships", { contact: null, search });

					this.isLoadingT = false;
				}, 300);
			},
			clear() {
				this.isLoadingT = false;
				this.validEstablishmentsT = [];
				this.customerName = null;
				this.third_account = null;

				this.$store.dispatch("relationships");
			},
			constructAddress(place) {
				const { street_number, route, route2 } = place;
				var line = [
					street_number ?? "",
					route ?? "",
					route2 ? `- ${route2}` : "",
				];
				return line.filter(n => n).join(' ').trim();
			},
			constructLocation(place) {
				const { postal_code, locality, country } = place;
				var line = [
					postal_code ?? "",
					locality ?? "",
					country ? `- ${country}` : "",
				];
				return line.filter(n => n).join(' ').trim();
			},
			constructFormattedAdress(place) {
				return this.constructAddress(place) + ' ' + this.constructLocation(place);
			},
			onInput({ newVal }) {
				this.third_account.address = newVal;
			},
			onPlaceChange(place) {
				if (!place)
					return;

				this.third_account.address = this.constructAddress(place);
				this.third_account.location = this.constructLocation(place);
      			this.inputKeyT += 1;
			},
			getImageLink(item) {
				if (item?.image && item.image.slice(0, 1) === "/") {
					return `https://sinao.app${item.image}`;
				} else if (item?.initials) {
					return `https://sinao.app/services/avatar/${item.initials}/${item.initials}`;
				} else if (item?.name) {
					return `https://sinao.app/services/avatar/${item.name.charAt(0)}/${item.name.charAt(0)}`;
				} else {
					return "";
				}
			},
			stringToHSLColor(inputString, s = 70, l = 60) {
				let hash = 0;

				for (let i = 0; i < inputString.length; i++) {
					hash = inputString.charCodeAt(i) + ((hash << 5) - hash);
				}

				const hue = hash % 360;
				return `hsl(${hue}, ${s}%, ${l}%)`;
			},
			modalTiersCreation() {
				this.$bvModal.show("modalTiersCreation");
			},
			modalSinaoClientCreation(contactType) {
				this.dispatchEvent({
					modalName: null,
					source: "billing",
					action: "creation_client",
					data: { contactType }
				});
			}
		}
	};
</script>

<template>
	<b-row style="padding: 10px 5px">
		<!-- Show the clients -->
		<b-col v-if="!third_account" cols="12">
			<Multiselect
				:options="contacts"
				:placeholder="$t('Sélectionner un tiers')"
				:show-labels="false"
				label="name"
				track-by="name"
				:allow-empty="false"
				:internal-search="false"
				:loading="isLoadingT"
				:clear-on-select="false"
				:show-no-results="false"
				@select="selectContact"
				@search-change="clientsSearch"
			>
				<template #noOptions>
					{{ $t("La liste est vide.") }}
				</template>

				<!-- Options on the select -->
				<template slot="option" slot-scope="props">
					<div style="display: flex; align-items: center;">
						<div v-if="props.option.name" class="custom-avatar" :style="props.option.name ? `background-color: ${stringToHSLColor(props.option.name)}` : null">
							{{ props.option.name.slice(0, 1) }}
						</div>
						<b-img-lazy v-else :src="getImageLink(props.option)" class="option__image" />

						<div class="option__desc">
							<span class="option__title">{{ props.option["name"] | truncate(30) }}</span>
						</div>
					</div>
				</template>
			</Multiselect>

			<b-button size="sm" class="sinao-button-default" block variant="light" @click="modalTiersCreation">
				+ {{ $t("Créer un tiers") }}
			</b-button>
		</b-col>

		<!-- Show the selected client -->
		<b-col v-else cols="12">
			<b-row>
				<b-col cols="2" class="mt-8">
					<div v-if="third_account.name" class="custom-avatar-big" :style="third_account.name ? `background-color: ${stringToHSLColor(third_account.name)}` : null">
						{{ third_account.name.slice(0, 1) }}
					</div>
					<b-img-lazy v-else :src="getImageLink(third_account)" class="option__image" />
				</b-col>

				<b-col cols="10" class="ml-10">
					<b-form-input
						v-model.lazy="third_account.name"
						:placeholder="$t('Dénomination')"
						style="font-weight: bold"
						class="billing__input billing__input--borderBottom billing__input--dashed"
					/>
				</b-col>
			</b-row>

			<b-row class="pt-1">
				<b-col cols="12">
					<vue-google-autocomplete
						id="map"
						ref="addressPicker"
						v-model.lazy="third_account.address"
						:key="inputKeyT"
						:placeholder="$t('Adresse')"
						classname="text-center billing__input billing__input--borderBottom billing__input--dashed billing__input--fullWidth"
						style="color: var(--black)"
						:country="['fr']"
						@placechanged="onPlaceChange"
						@inputChange="onInput"
					/>
				</b-col>
			</b-row>

			<b-row class="pt-1">
				<b-col cols="12">
					<b-form-input
						v-model.lazy="third_account.location"
						:key="inputKeyT"
						:placeholder="$t('Code postal - Ville - Pays')"
						class="text-center billing__input billing__input--borderBottom billing__input--dashed"
					/>
				</b-col>
			</b-row>

			<!-- Select an establishment -->
			<b-row style="margin-left: 20px; min-height: 10px">
				<b-col cols="6">
					<b-dropdown
						v-if="validEstablishmentsT.length !== 0"
						size="sm"
						:text="$t('Adresses')"
						class="m-2"
						variant="light"
					>
						<b-dropdown-item
							v-for="(establishment, index) in validEstablishmentsT"
							:key="index"
							@click="onPlaceChange(establishment.place)"
						>
							{{ constructFormattedAdress(establishment.place) || $t("Sans adresse") }}
						</b-dropdown-item>
					</b-dropdown>
				</b-col>

				<b-col v-if="appId !== 0" cols="6">
					<b-button class="mt-2" style="font-size: 12px" variant="link" @click="clear">
						<b-icon icon="x" /> {{ $t("Changer de tiers") }}
					</b-button>
				</b-col>
			</b-row>
		</b-col>

		<b-modal id="modalTiersCreation" :title="$t('Création de tiers')" hide-footer>
			<s-button type="default" class="mr-3" @click="modalSinaoClientCreation('person')">
				<b-icon icon="person-fill" /> &nbsp; {{ $t("Nouveau particulier") }}
			</s-button>

			<s-button type="success" class="ml-3" @click="modalSinaoClientCreation('organization')">
				<b-icon icon="building" /> &nbsp; {{ $t("Nouvelle entreprise") }}
			</s-button>
		</b-modal>
	</b-row>
</template>

<style lang="scss">
	@import "../../scss/multiselect.scss";

	.custom-avatar-big {
		width: 32px;
		height: 32px;
		border-radius: 30px;
		font-size: 13px;
		color: var(--white);
		font-weight: 400;
		display: grid;
		justify-content: center;
		align-items: center;
		margin: 0 5px;
		margin-left: 19px;
	}

	#modalTiersCreation___BV_modal_body_ {
		display: flex;
	}
</style>
